import React, { useState, useEffect } from 'react';
import { IconSend } from '@tabler/icons-react';

import { Input, Button } from '../IDSK';
import { useWebsockets } from '../../context/websockets';
import { sanitizeUserInput } from '../../utils/sanitize';

const MAX_MESSAGE_LENGTH = 10000;

type NewMessageProps = {
    disabled: boolean;
    activeConversation: string | null;
};

export default function NewMessage(props: NewMessageProps) {
    const ws = useWebsockets();
    const inputRef = React.useRef<HTMLInputElement>(null);
    const startedListenerRef = React.useRef<(() => void) | null>(null);
    const [text, setText] = useState('');

    useEffect(() => {
        return () => {
            if(startedListenerRef.current) {
                startedListenerRef.current();
                startedListenerRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        if(!props.disabled && inputRef.current) {
            inputRef.current.focus();
        }
    }, [props.disabled]);

    const sendMessage = () => {
        if(props.disabled || !props.activeConversation) {
            return;
        }

        const sanitizedMessage = sanitizeUserInput(text, MAX_MESSAGE_LENGTH);

        if(sanitizedMessage.length === 0) {
            return;
        }

        setText('');

        ws.sendMessage('send-message', {
            conversation: props.activeConversation,
            message: sanitizedMessage,
        });
    };

    const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        if(value.length <= MAX_MESSAGE_LENGTH) {
            setText(value);
        }
    };

    return <>
        <div className="chat--popup--new-message">
            <div className="chat--popup--new-message--row">
                <Input
                    ref={inputRef}
                    value={text}
                    onChange={handleTextChange}
                    placeholder="Napíšte vašu správu..."
                    maxLength={MAX_MESSAGE_LENGTH}
                    onKeyUp={(e) => {
                        if(e.key === 'Enter') {
                            sendMessage();
                        }
                    }}
                    disabled={props.disabled}
                />

                <Button onClick={sendMessage} disabled={props.disabled}>
                    <IconSend /> Odoslať
                </Button>
            </div>

            <div className="chat--popup--disclaimer">
                Odpovede chatbota môžu obsahovať nepresnosti alebo chyby. Pred použitím si vždy overte informácie z dôveryhodných zdrojov. Do chatbota nezadávajte osobné údaje, citlivé údaje, heslá, prihlasovacie údaje ani iné dôverné informácie.
            </div>
        </div>
    </>;
}
